"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var venn = require("venn.js");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var Venn = /** @class */ (function (_super) {
    __extends(Venn, _super);
    function Venn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getChartData = function (data) {
            var layoutFunction = venn.venn;
            var loss = venn.lossFunction;
            var toRemove = {};
            data.forEach(function (datum) {
                if ((datum.size === 0) && datum.sets.length === 1) {
                    toRemove[datum.sets[0]] = 1;
                }
            });
            data = data.filter(function (datum) {
                return !datum.sets.some(function (set) { return set in toRemove; });
            });
            var circles = {};
            var textCentres = {};
            if (data.length > 0) {
                var solution = layoutFunction(data, { lossFunction: loss });
                if (_this._normalize) {
                    solution = venn.normalizeSolution(solution, _this._orientation, null);
                }
                circles = venn.scaleSolution(solution, _this._cachedWidth, _this._cachedHeight, _this._padding);
                textCentres = venn.computeTextCentres(circles, data);
            }
            return {
                circles: circles,
                textCentres: textCentres,
            };
        };
        return _this;
    }
    Venn.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_padding":
            case "_orientation":
                return utils_1.parseNumberWithAuto(value);
            case "_isNormolize":
                return utils_1.parseBoolean(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Venn.prototype.defaultOptions = function () {
        return {
            _padding: 15,
            _orientation: Math.PI / 2,
            _normalize: true,
        };
    };
    Venn.prototype.init = function () {
        this._toolTip = __1.tooltip.create("bartip");
        this._circles = this.appendGroupT(element_1.Circle).data([]).options({
            _r: function (d) { return d.radius; },
            _x: function (d) { return d.x; },
            _y: function (d) { return d.y; },
            class: function (d) { return d.class.replace(/\s/g, "").replace(/,/g, "_"); },
            opacity: "0.5",
            fill: "white",
            stroke: "grey",
            _$mouseEnter: function (d, i, g) {
                g[i].style.opacity = "0.9";
            },
            _$mouseLeave: function (d, i, g) {
                g[i].style.opacity = "0.5";
            },
        });
        this._labels = this.appendGroupT(element_1.Text).data([]).options({
            _text: function (d) { return d.class; },
            _x: function (d) { return d.x; },
            _y: function (d) { return d.y; },
            class: function (d) { return d.class.replace(/\s/g, "").replace(/,/g, "_"); },
        });
    };
    Venn.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        this._cachedHeight = this._getGeometry("_height", false);
        this._cachedWidth = this._getGeometry("_width", true);
        // Use functions in venn.js to get the postion of the circles and texts
        var data = this.getChartData(this.datum);
        // Modifies the format of data for both circles and texts
        var circleData = Object.keys(data.circles).map(function (key) {
            var obj = data.circles[key];
            obj.class = key;
            return obj;
        });
        var labelData = Object.keys(data.textCentres).map(function (key) {
            var obj = data.textCentres[key];
            obj.class = key;
            return obj;
        });
        this._circles.data(circleData);
        this._labels.data(labelData);
        this.setupProxy({
            circle: "_circles",
            label: "_labels",
        });
    };
    Venn.prototype.postOptionsUpdate = function () {
        this._padding = this.getOption("_padding");
        this._orientation = this.getOption("_orientation");
        this._normalize = this.getOption("_normalize");
    };
    return Venn;
}(_1.Component));
exports.Venn = Venn;
//# sourceMappingURL=venn.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/venn.js
// module id = 1152
// module chunks = 0 1